import NextChapterCard from "./NextChapterCard";

export default NextChapterCard;
